import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Grid from '@mui/material/Grid';
import { FC, useContext, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { DialogActions, DialogContentText, FormControlLabel } from '@mui/material';
import { Button, Checkbox, FormButton } from 'thermia-react-container';
import { RegistrationsContext } from '../../../../context/contextProvider';

interface Props {
  loading: boolean;
  handleClick: () => void;
  handleCancel: () => void;
}

const CompleteForm: FC<Props> = ({ loading, handleClick, handleCancel }) => {
  const [gdprCompliant, setGdprCompliant] = useState(false);
  const { registrations } = useContext(RegistrationsContext);
  const { activeRegistration } = registrations;

  const { t } = useTranslation('registrations');

  const handleChange = () => {
    setGdprCompliant(!gdprCompliant);
  };

  const gdprComplianceString = (
    <p>
      {t('registrations.general.gdprCompliance')}{' '}
      <a href="https://privacy.thermia.com" target="_blank" rel="noreferrer">
        https://privacy.thermia.com
      </a>
    </p>
  );
  return (
    <>
      <DialogTitle>{t('registrations.general.completeRegistration')}</DialogTitle>

      <DialogContent>
        <DialogContentText>{t('registrations.general.completeRegistrationQuestion')}</DialogContentText>
        <Grid container paddingBottom={'20px'} paddingTop={'20px'}>
          <Grid item xs={3}>
            <DialogContentText fontWeight={'bold'}>{`${t('registrations.general.customer')}`}</DialogContentText>
          </Grid>
          <Grid item xs={9} container>
            <Grid item xs={12}>
              <DialogContentText>{`${activeRegistration?.customer?.firstName} ${activeRegistration?.customer?.lastName}`}</DialogContentText>
            </Grid>
            <Grid item xs={12}>
              <DialogContentText>{`${activeRegistration?.customer?.email} `}</DialogContentText>
            </Grid>
          </Grid>

          <Grid item container>
            <Grid item xs={3}>
              <DialogContentText fontWeight={'bold'}>{`${t('registrations.general.location')}`}</DialogContentText>
            </Grid>
            <Grid item xs={9} container>
              <Grid item xs={12}>
                <DialogContentText>{`${activeRegistration?.location?.propertyType}`}</DialogContentText>
              </Grid>
              <Grid item xs={12}>
                <DialogContentText>{`${activeRegistration?.location?.installationAddress}`}</DialogContentText>
              </Grid>
              <Grid item xs={12}>
                <DialogContentText>{`${activeRegistration?.location?.zipCode} ${activeRegistration?.location?.city}`}</DialogContentText>
              </Grid>
            </Grid>
          </Grid>

          <Grid container item xs={12}>
            <Grid item xs={3}>
              <DialogContentText fontWeight={'bold'}>{`${t('registrations.general.device', { context: 'plural' })}`}</DialogContentText>
            </Grid>
            <Grid item container xs={9}>
              {(activeRegistration?.devices?.items ?? []).map((device) => (
                <Grid item key={device.serialNumber}>
                  <DialogContentText>{`${device.articleName} - ${device.serialNumber}`}</DialogContentText>
                </Grid>
              ))}
            </Grid>
          </Grid>
        </Grid>
        <div style={{ border: '1px solid black', borderRadius: '5px', padding: '17px' }}>
          <FormControlLabel control={<Checkbox label="" checked={gdprCompliant} onClick={() => handleChange()} />} label={gdprComplianceString} />
        </div>
      </DialogContent>

      <DialogActions>
        <Button onClick={handleCancel} title={t('registrations.general.cancel')} />
        <FormButton
          variant={'contained'}
          onClick={handleClick}
          title={t('registrations.general.complete')}
          loading={loading}
          style={{ marginLeft: '0px' }}
          disabled={!gdprCompliant}
        />
      </DialogActions>
    </>
  );
};

export default CompleteForm;
